export default __webpack_public_path__ + "static/media/mapbox.0b115cf2.svg";